import { render, staticRenderFns } from "./ProjectBMETEdit.vue?vue&type=template&id=e5bc6534&"
import script from "./ProjectBMETEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectBMETEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports